import { Observable } from 'rxjs';
import { StorageParameters } from '../storage.service';
import { ApiBase } from './api.base';


export class AnnouncementApi extends ApiBase {
  model = 'announcements';

  public read(id: string, foundationId: string): Observable<{success: true}> {
    return this.http.post<{success: true}>(
      this.buildUrl(id, 'read'),
      {foundationId},
      {
        headers: this.setHeaders({
          'Authorization': this.getStorage().getItem(StorageParameters.AccessTokenId)
        })
      },
    );
  }
}
